<div class="sub-header-draft-container">
  <div class="indicate-draft">
    <u-icon [model]="{ type: 'font', value: 'icon-draft' }" [styles]="{ fontSize: '14px' }"></u-icon>
    <div class="text-draft">Draft</div>
  </div>
  <div class="draft-status">
    <u-icon
      *ngIf="iconStatus"
      [model]="{ type: 'font', value: iconStatus }"
      [styles]="{ fontSize: '12px', color: 'var(--color-text-tertiary)' }"
    ></u-icon>
    <div class="text-status" [pTooltip]="modifiedTimeTooltip" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">{{ textStatus }}</div>
  </div>
</div>
